export const FILTERS_ONE_PLATFORM_REPLACE_ALL_FILTERS = 'FILTERS_ONE_PLATFORM_REPLACE_ALL_FILTERS';
export const FILTERS_ONE_PLATFORM_REPLACE_FILTER = 'FILTERS_ONE_PLATFORM_REPLACE_FILTER';
export const FILTERS_ONE_PLATFORM_PATCH_FILTER = 'FILTERS_ONE_PLATFORM_PATCH_FILTER';
export const FILTERS_ONE_PLATFORM_RECOVER_ALL_FILTERS_ALL_REPORTS = 'FILTERS_ONE_PLATFORM_RECOVER_ALL_FILTERS_ALL_REPORTS';